export default "__VITE_ASSET__BE6GDUJW__"